import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.Standalone.StandaloneDescriptionSection', {
    descriptionLabel: 'Description',
    buttonShowLess: 'Show less',
    buttonShowMore: 'Show the full description',
});
